import React from "react";
import { graphql } from "gatsby"
import Block from "../../Block";

class HowToBlock extends Block {
  render() {
    const { block } = this.props;

    const entries = block.originalContent.replace(/<li/ig, '\n<li').replace(/(<([^>]+)>)/ig, '').split('\n')

    let items = []
    for (let i = 1; i < entries.length; i++)
      items.push(<li key={i}>{entries[i]}</li>)

    return (
      <div className="schema-how-to wp-block-yoast-how-to-block">
        <div className="schema-how-to-description">{entries[0]}</div>
        <ol className="schema-how-to-steps">
          {items}
        </ol>
      </div>
    )
  }
}

class HowToBlockFactory {
  get type() {
    return "yoast/how-to-block";
  }

  create(props) {
    return <HowToBlock {...props} />;
  }
}

export default HowToBlockFactory;
